import { useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Layout } from '@utilities';

import ModalBuildNarrative from '../Narratives/components/ModalBuildNarrative';
import NarrativeFlowView from '../../components/NarrativeFlowView';
import Page from '../../layouts/Page';

export const Narrative = ({ id, publicToken }) => {
  // if flowId is not passed as a prop, look for param in the URL params
  let { flow_id: flowId } = useParams();
  flowId = Number(id || flowId);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const handleReprompt = (prompt = null) => {
    setSelectedPrompt(prompt);
    setIsModalOpen(true);
  };
  return (
    <NarrativeFlowView
      flowId={flowId}
      onReprompt={handleReprompt}
      publicToken={publicToken}
      renderAfterContent={({ flow, narrativeRoute }) =>
        isModalOpen ? (
          <ModalBuildNarrative
            flowId={flow?.id}
            projectId={flow?.projectId ?? null}
            route={narrativeRoute}
            selectedPrompt={selectedPrompt}
            setIsModalOpen={setIsModalOpen}
            topicIds={flow?.topic_ids}
          />
        ) : null
      }
    />
  );
};

Narrative.propTypes = {
  id: PropTypes.number,
  /*
   * Optional: only required for sharing the narrative publicly
   */
  publicToken: PropTypes.string,
};

const NarrativeLayout = (props) => (
  <Page>
    <Layout.Column>
      <Narrative {...props} />
    </Layout.Column>
  </Page>
);

export default NarrativeLayout;
